module.exports = __webpack_public_path__ + "assets/img/85.62851c47.png";